import BaseModel from 'models/base-model';
import { SocketClient, SOCKET_CONNECTION_TYPE } from 'socket/socketio-client';
import { SignalrClient } from 'socket/signalr-client';
import {
  updateElementCacheByCalloutAction,
  updateElementCacheFromSocketPayloadAction,
  updateElementCacheByCalloutPosition,
  resetCalloutPositionsInsideElementCache,
} from 'store/actions/element-cache-actions';
import {
  updateElementPanelFromSocketPayload,
  removeElementFromFormulaTabFromSocketPayloadAction,
  addFormulaToFormulaListFromSocketPayloadAction,
  updateFormulaListElementsFromSocketPayloadAction,
  elementWorkpaperListFromWebSocketPayloadAction,
  removeWorkpaperFromElementPanelWithSocketPayload,
  elementWorkpaperListLoadedWithoutResponse,
  removeWPFromElementPanelAction,
  updateWPFromElementPanelAction,
  updateTickmarkInElementPanelWithSocketPayloadAction,
  removeTickmarkFromElementPanelWithSocketPayloadAction,
  elementTickmarkListFromWebSocketPayloadAction,
  removeTickmarkWithSocketPayloadInBulk,
  elementTickmarkListLoadedWithoutResponse,
  getElementFormulasWithoutLoading,
  updateComfortLetterInElementPanelWithSocketPayloadAction,
  removeComfortLetterFromElementPanelWithSocketPayloadAction,
  elementComfortAnnotationListFromWebSocketPayloadAction,
  removeComfortLetterFromElementPanelWithSocketPayloadInBulk,
  elementComfortLetterListLoadedWithoutResponse,
} from 'store/actions/element-panel-actions';
import {
  updateElementDetailsFromLeftPanel,
  elementFormulaListLoadedWithoutResponse,
} from 'store/actions/common/element-panel-actions';
import {
  updateElementFilterFromSocketPayload,
  showElementSearchRefreshButtonAction,
} from 'store/actions/statement-navigator/elements-search-panel-actions';
import {
  updateSelectedBatchElementsFromSocketAction,
  removeBatchElementsFromSocketPayloadAction,
} from 'store/actions/batch-panel-actions';
import { LEFT_PANELS, RIGHT_PANELS } from 'constants/feature/panel-constants';
import {
  updateInternalReferenceElementsFromSocketAction,
  updateInternalReferenceFromSocketAction,
  setInternalReferenceLoadedWithoutPayload,
} from 'store/actions/internal-reference-actions';
import ElementDetails from 'models/api/element-details-api-model';
import {
  updateSuggestedIRElementsFromListFromSocketPayloadAction,
  fetchSuggestedListedWithoutLoading,
} from 'store/actions/internal-reference-suggestion-list-actions';
import {
  fetchStatementSummarySections,
  updateSectionSummaryFromSocketPayloadAction,
} from 'store/actions/statement-summary/sections-summary-actions';
import { updateElementSummaryFromSocketPayloadAction } from 'store/actions/statement-summary/elements-summary-actions';
import {
  fetchSectionHTMLSegmentsStatementContentWithoutLoading,
  fetchAllSectionRenderingDataWithoutLoading,
} from 'store/actions/statement-content-actions';
import {
  removeElementsFromElementsMapWithSocketPayloadAction,
  fetchWorkpaperListForRevisionWithoutLoading,
  addWorkpaperToListAction,
  unlinkWorkpaperFromElementWithWebsocketPayload,
  deleteWorkpaperWithSocketPayloadAction,
  updateWorkpaperWithSocketPayloadAction,
} from 'store/actions/workpaper-toolkit-list-actions';
import {
  removeElementFromTickmarkElementsMapWithSocketPayloadAction,
  fetchTickmarkListForRevisionWithoutLoading,
  deleteTickmarkWithSocketPayloadAction,
  updateTickmarkWithSocketPayloadAction,
  addTickmarkToListAction,
  unlinkTickmarkFromElementWithWebsocket,
} from 'store/actions/tickmark-list-panel-actions';
import { addComfortAnnotationToListAction } from 'store/actions/comfort-annotations-list-actions';
import {
  addUserAfterValidatingIfIdExists,
  removeUserAction,
  // removeUserFromRoomAction,
} from 'store/actions/active-users-actions';
import {
  removeFormulaWithSocketPayloadAction,
  updateFormulaElementsFromSocketPayloadAction,
} from 'store/actions/formula-actions';
import { hideElementPanelAction } from 'store/actions/panel-controller-actions';
import { isNullOrUndefined } from 'utils/object-utils';
import { setElementSelectModeDefaultAction } from 'store/actions/modes-actions';
import { updateSummaryNotesFromWebsocket } from 'store/actions/statement-summary/notes-summary-actions';
import {
  deleteNoteWithWebsocketPayload,
  notesListLoadedWithoutReponse,
  addNoteWithWebsocketPayload,
  selectNoteFromNoteListAction,
  updateNoteWithWebsocketPayload,
} from 'store/actions/notes-panel-actions';
import Note from 'models/data/note-model';
import {
  removeNoteFromCacheWithSocketPayloadAction,
  updateNoteFromNoteCacheWithSocketPayloadAction,
} from 'store/actions/notes-cache-actions';
import { setStatementNavigationRefresh } from 'store/actions/statement-navigator/navigator-panel-actions';
import {
  appendSectionToSectionReviewList,
  mergeSectionReviewToSectionReviewList,
  removeSectionReviewFromStore,
  removeBulkSectionReviewFromStore,
} from 'store/actions/sections-actions';
import {
  appendSectionReviewHistory,
  fetchSectionHistoryDetails,
} from 'store/actions/section-review-history-actions';
import {
  updateSectionAssignmentListFromSocket,
  replaceNewWithSocketData,
  updateSectionAssignmentListForBulkAssignFromSocket,
  updateSectionAssignmentListForBulkUnAssignFromSocket,
  updateSectionAssignmentInBulkFromSocket,
} from 'store/actions/section-assignment-actions';
import { enableRefreshIconAction } from 'store/actions/preview-report-page-actions';
import { downloadReportAction } from 'store/actions/toolkit-export-panel-actions';
import { setHeadingAssignmentRefresh } from 'store/actions/section-assignment-heading-refresh-actions';
import {
  fetchComfortAnnotationListForRevisionWithoutLoading,
  removeElementFromComfortLetterElementsWithSocketPayloadAction,
  updateComfortLetterWithSocketPayloadAction,
  deleteComfortLetterWithSocketPayloadAction,
  unlinkComfortLetterFromElementWithWebsocket,
} from 'store/actions/comfort-annotations-list-actions';
import { updateCacheWithMostRecentElementChanges } from 'store/actions/element-changes-since-tracker-actions';
// WEBSOCKET EVENT TYPE CONSTANTS
import { NOTIFICATION_EVENT_TYPES } from 'constants/web-socket-constants';
import {
  blacklineTogleNotification,
  getWebsocketElementsForCalloutChange,
  isElementHasAnyAnnotations,
} from 'utils/statement-content-page-utils';
import { refetchSectionsInView } from '../../store/actions/statement-content-actions';
import { BLACKLINE_VIEW_STATUS } from '../../constants/feature/statement-content-constants';
import {
  getWebSocketNotificationType,
  getWebSocketPayload,
} from 'constants/util/web-socket-utils';
import { isSignalRForSocketConnectionEnabled } from 'api/api-constants';
import { getUserNameByUserData } from 'utils/statement-content-page-utils';
import { isElementReportPreviewPage } from 'utils/ocr-annotation-utils';
import {
  fetchElementsBySectionOCR,
  fetchNotesBySectionOCR,
} from 'store/actions/statement-content-actions-ocr';

export default class StatementSocketModel extends BaseModel({
  client: null,
  socketHasBeenDisconnected: true,
}) {
  init(config = {}) {
    if (isSignalRForSocketConnectionEnabled) {
      const client = new SignalrClient({ ...config });
      return this.merge({ ...this, client });
    } else {
      const client = new SocketClient({
        ...config,
        userId: config.currentUserId,
        socketConnectionType: SOCKET_CONNECTION_TYPE.REVISION,
      });
      return this.merge({ ...this, client });
    }
  }

  setSocketClient(store) {
    if (this.client) {
      this.client.on('newMessage', (event) =>
        this.onEventHandler(event, store),
      );
    }
    return this;
  }

  stopSocketConnection() {
    //if application is enabled with signalr socket connection
    if (
      isSignalRForSocketConnectionEnabled &&
      this.client &&
      this.client.connection
    ) {
      this.client.connection.stop();
    }
    //if application is enabled with socket connection
    if (!isSignalRForSocketConnectionEnabled && this.client) {
      this.client._closeSocketConnection();
      this.client.disconnect();
      return this.merge({ ...this, socketHasBeenDisconnected: true });
    }
    return this;
  }

  setSocketDisconnect(payload) {
    return this.merge({ ...this, socketHasBeenDisconnected: payload });
  }

  onEventHandler(event, store) {
    // This dispatch and getState is from the store and will allow us to update data throughout the app
    const { dispatch, getState } = store;
    const storeData = getState().data;
    const { revision } = storeData;
    const {
      data: {
        currentUser,
        sectionPanel: { selectedSection },
        projectUsersList,
        selectedStatement,
      },
      ui: {
        statementPage: {
          sectionsInView,
          panels: { right, left },
          statementNavigatorPanel: { elementSearchResults },
          modes: { blacklineViewMode },
        },
      },
    } = getState();

    const pathname = window.location.pathname;
    const { elementDetails, formulaList } = storeData.elementPanel;
    const { internalReference } = storeData.elementPanel;
    const { formula } = storeData.formulaPanel;
    const { internalReferenceSuggestionList } =
      storeData.internalReferencePanel;
    const { elementCache } = storeData.statementContent;
    const isOCRStatement = selectedStatement.isOCR;

    const _elementUpdate = (webSocketPayload) => {
      // this action updates the elements in the content in real time

      /**  getWebsocketElementsForCalloutChange method will compares the previous and current(webSocketPayload) element annotations
       * if any annotations related changes were done on then element/s then if update the callout and marker values accordingly
       * based on the loaded section wise element data
       */
      const webSocketElementsData = getWebsocketElementsForCalloutChange(
        elementCache,
        webSocketPayload,
      );
      dispatch(
        updateElementCacheFromSocketPayloadAction(webSocketElementsData),
      );

      // this action updates the element details in the TM/WP panel
      // this action only gets called if the user has the TM/WP open
      dispatch(
        updateElementDetailsFromLeftPanel({
          elementsArray: webSocketPayload,
        }),
      );

      if (right === RIGHT_PANELS.ELEMENT) {
        const _elementMap = webSocketPayload.reduce(
          (elementMap, elementData) => {
            const payload = { response: { data: { result: elementData } } };
            elementMap[elementData.id] = new ElementDetails().setLoaded(
              payload,
            );
            return elementMap;
          },
          {},
        );

        if (internalReferenceSuggestionList.isLoaded) {
          dispatch(
            updateSuggestedIRElementsFromListFromSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }

        dispatch(updateInternalReferenceElementsFromSocketAction(_elementMap));

        // this action updates the element panel in real time if the updated element
        // is viewed in the element panel by the user
        if (webSocketElementsData.length > 0) {
          const element = webSocketElementsData.find(
            (elem) => elem.id === elementDetails.id,
          );
          if (element) {
            dispatch(updateElementPanelFromSocketPayload(element));
          }
        }

        // Update formula list if any formula rows contain the updated elements
        if (formulaList && formulaList.isLoaded && formulaList.hasFormulas()) {
          dispatch(
            updateFormulaListElementsFromSocketPayloadAction({
              elementsArray: webSocketElementsData,
            }),
          );
        }

        // Update formula being edited if it contains the updated elements
        if (formula && formula.data && formula.hasRows()) {
          dispatch(
            updateFormulaElementsFromSocketPayloadAction({
              elementsArray: webSocketElementsData,
            }),
          );
        }
      }

      // this action updates the element filter list when a user makes an update to an element
      // this action will only be called if the elements tab is selected and if there are
      // element filters applied
      dispatch(updateElementFilterFromSocketPayload(webSocketPayload));

      // this action updates the selected elements in the batch panel
      // this action will only be called if the batch panel is open
      if (right === RIGHT_PANELS.BATCH) {
        dispatch(updateSelectedBatchElementsFromSocketAction(webSocketPayload));
      }

      // this action will determine if the element search content component will render the
      // filter refresh button
      if (elementSearchResults.isLoaded) {
        dispatch(showElementSearchRefreshButtonAction(true));
      }
    };

    const webSocketPayload = getWebSocketPayload(event);
    let elementToFormulasObject = {};
    let irElement = null;
    const notificationType = getWebSocketNotificationType(event);

    if (
      isElementReportPreviewPage(pathname) &&
      notificationType !== NOTIFICATION_EVENT_TYPES.ELEMENT_ADD &&
      notificationType !== NOTIFICATION_EVENT_TYPES.ELEMENT_EXCLUDE
    )
      return;

    switch (getWebSocketNotificationType(event)) {
      // case for single and batch element status updates
      case NOTIFICATION_EVENT_TYPES.ELEMENT_UPDATE:
        _elementUpdate(webSocketPayload);
        break;

      case NOTIFICATION_EVENT_TYPES.ELEMENT_ADD:
        dispatch(enableRefreshIconAction());
        dispatch(showElementSearchRefreshButtonAction(true));
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            updateInternalReferenceElementsFromSocketAction(
              webSocketPayload.reduce((elementMap, elementData) => {
                const payload = { response: { data: { result: elementData } } };
                elementMap[elementData.id] = new ElementDetails().setLoaded(
                  payload,
                );
                return elementMap;
              }, {}),
            ),
          );
        }
        if (isOCRStatement) {
          dispatch(
            fetchElementsBySectionOCR({
              sectionId: webSocketPayload[0].sectionId,
              withoutLoading: true,
            }),
          );
        } else {
          dispatch(
            fetchAllSectionRenderingDataWithoutLoading({
              sectionId: webSocketPayload[0].sectionId,
            }),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.ELEMENT_EXCLUDE:
        // removes elements to selected elements in batch panel when open
        dispatch(enableRefreshIconAction());
        dispatch(showElementSearchRefreshButtonAction(true));
        if (right === RIGHT_PANELS.BATCH) {
          dispatch(
            removeBatchElementsFromSocketPayloadAction(webSocketPayload),
          );
        }

        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            updateInternalReferenceElementsFromSocketAction(
              webSocketPayload.reduce((elementMap, elementData) => {
                const payload = { response: { data: { result: elementData } } };
                elementMap[elementData.id] = new ElementDetails().setLoaded(
                  payload,
                );
                return elementMap;
              }, {}),
            ),
          );

          // removes element from formula edit panel if the formula panel contains the removed element
          if (formula.data.formulaElementDtoList) {
            dispatch(removeFormulaWithSocketPayloadAction(webSocketPayload));
          }

          // close element panel if the element is removed
          if (
            webSocketPayload.length > 0 &&
            elementDetails.id === webSocketPayload[0].id
          ) {
            dispatch(hideElementPanelAction());
            dispatch(setElementSelectModeDefaultAction());
          }
        }
        _elementUpdate(webSocketPayload);
        if (!isOCRStatement) {
          // Update the content panel html thru api and not signalr
          dispatch(
            fetchSectionHTMLSegmentsStatementContentWithoutLoading({
              sectionIdList: Array.from(
                new Set(webSocketPayload.map((element) => element.sectionId)),
              ),
              segmentType: blacklineViewMode ? 'C' : 'P',
            }),
          );
        } else {
          dispatch(updateCacheWithMostRecentElementChanges());
        }

        // update WP element list if user has the Workpaper panel open
        if (left === LEFT_PANELS.WORKPAPER) {
          dispatch(
            fetchWorkpaperListForRevisionWithoutLoading({
              revisionId: revision.id,
            }),
          );
          dispatch(
            removeElementsFromElementsMapWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }

        // update TM element list if user has the Tickmark panel open
        if (left === LEFT_PANELS.TICKMARK) {
          dispatch(
            fetchTickmarkListForRevisionWithoutLoading({
              revisionId: revision.id,
            }),
          );
          dispatch(
            removeElementFromTickmarkElementsMapWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }

        // update Comfort Annotation elements list if user has the Comfort Annotation panel open
        if (left === LEFT_PANELS.COMFORT_ANNOTATION) {
          dispatch(
            fetchComfortAnnotationListForRevisionWithoutLoading({
              revisionId: revision.id,
            }),
          );
          dispatch(
            removeElementFromComfortLetterElementsWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }

        break;

      // update the summary count for verified, reviewed, and flagged elements
      case NOTIFICATION_EVENT_TYPES.ELEMENT_SUMMARY:
        dispatch(updateElementSummaryFromSocketPayloadAction(webSocketPayload));
        break;

      // update the summary count for sections
      case NOTIFICATION_EVENT_TYPES.HEADING_SUMMARY:
        dispatch(updateSectionSummaryFromSocketPayloadAction(webSocketPayload));
        break;

      case NOTIFICATION_EVENT_TYPES.FORMULA_DELETED:
        // remove formula from formula tab if the user has the affected element open
        if (right === RIGHT_PANELS.ELEMENT) {
          for (let i = 0; i < webSocketPayload.length; i++) {
            const element = webSocketPayload[i];
            const elementId = element.elementId;
            const formulasIds = element.formulaIds;
            elementToFormulasObject[elementId] = new Set(formulasIds);
          }

          if (elementToFormulasObject[elementDetails.id]) {
            dispatch(
              removeElementFromFormulaTabFromSocketPayloadAction(
                elementToFormulasObject[elementDetails.id],
              ),
            );
          }
        }

        // render refresh button on element search
        if (elementSearchResults.isLoaded) {
          dispatch(showElementSearchRefreshButtonAction(true));
        }

        // this action updates the selected elements in the batch panel
        // this action will only be called if the batch panel is open
        if (right === RIGHT_PANELS.BATCH) {
          dispatch(
            updateSelectedBatchElementsFromSocketAction(webSocketPayload),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.FORMULA_SAVED:
        if (
          webSocketPayload &&
          elementDetails.id === webSocketPayload.elementId
        ) {
          dispatch(
            addFormulaToFormulaListFromSocketPayloadAction(webSocketPayload),
          );
        }

        // render refresh button on element search
        if (elementSearchResults.isLoaded) {
          dispatch(showElementSearchRefreshButtonAction(true));
        }

        // this action updates the selected elements in the batch panel
        // this action will only be called if the batch panel is open
        if (right === RIGHT_PANELS.BATCH) {
          dispatch(
            updateSelectedBatchElementsFromSocketAction(webSocketPayload),
          );
        }
        dispatch(elementFormulaListLoadedWithoutResponse());
        dispatch(
          updateElementCacheByCalloutAction({
            elementIds: [elementDetails.id],
            showCallout: true,
          }),
        );
        break;

      case NOTIFICATION_EVENT_TYPES.FORMULA_TYPE_CHANGED:
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            getElementFormulasWithoutLoading({
              elementId: elementDetails.id,
            }),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.INTERNAL_REFERENCE_UPDATE:
        for (let i = 0; i < webSocketPayload.length; i++) {
          irElement = webSocketPayload[i];
          if (!isNullOrUndefined(irElement.id)) {
            const isDifferentElement =
              !isNullOrUndefined(irElement.internalReferenceElements) &&
              !isNullOrUndefined(
                irElement.internalReferenceElements.find(
                  (element) => element.elementId === elementDetails.id,
                ),
              );
            // if its the same internal reference or the elementDetails is inside the internal reference elements list
            //we are going to update the IR information
            if (
              irElement.id === internalReference.data.id ||
              isDifferentElement
            ) {
              // if its the same internal reference id but the elements does not longer exist in the IR we are going to clear the IR info
              if (
                isNullOrUndefined(
                  irElement.internalReferenceElements.find(
                    (element) => element.elementId === elementDetails.id,
                  ),
                )
              ) {
                dispatch(updateInternalReferenceFromSocketAction(null));
              } else {
                //update the current internal reference object on the element details stored in redux
                dispatch(updateInternalReferenceFromSocketAction(irElement));
              }
              //we call this action to update the suggestion for the IR panel, only if the element is part of the IR.
              dispatch(
                fetchSuggestedListedWithoutLoading({
                  revisionId: revision.id,
                  elementId: elementDetails.id,
                }),
              );
              dispatch(setInternalReferenceLoadedWithoutPayload());
              break;
            }

            // this action will determine if the element search content component will render the
            // filter refresh button
            if (elementSearchResults.isLoaded) {
              dispatch(showElementSearchRefreshButtonAction(true));
            }
          }
        }

        break;

      case NOTIFICATION_EVENT_TYPES.WORKPAPER_LINKED:
        if (right === RIGHT_PANELS.ELEMENT) {
          const elementId = elementDetails.id;
          dispatch(
            elementWorkpaperListFromWebSocketPayloadAction({
              webSocketPayload: webSocketPayload.attachedWorkpapers,
              elementId,
            }),
          );
        }
        if (left === LEFT_PANELS.WORKPAPER) {
          dispatch(addWorkpaperToListAction(webSocketPayload));
        }
        //we call the element update function here because for WP element update event, we are not going to get anything for element update event
        // eslint-disable-next-line no-case-declarations
        let elementData;
        if (webSocketPayload.elementEntities) {
          elementData = webSocketPayload.elementEntities.map((element) => ({
            ...element,
            marker: false,
            callout: isElementHasAnyAnnotations(element),
          }));
        }
        _elementUpdate(elementData);
        break;

      case NOTIFICATION_EVENT_TYPES.USER_JOINED_REVISION_GROUP:
        dispatch(
          addUserAfterValidatingIfIdExists({ payload: webSocketPayload }),
        );
        break;
      case NOTIFICATION_EVENT_TYPES.USER_LEFT_REVISION_GROUP:
        dispatch(removeUserAction({ payload: webSocketPayload }));
        break;
      case NOTIFICATION_EVENT_TYPES.WORKPAPER_UNLINKED:
        if (left === LEFT_PANELS.WORKPAPER) {
          dispatch(
            unlinkWorkpaperFromElementWithWebsocketPayload(webSocketPayload),
          );
        }

        if (right === RIGHT_PANELS.ELEMENT) {
          const workpaperIdSet = new Set();
          for (let i = 0; i < webSocketPayload.length; i++) {
            workpaperIdSet.add(webSocketPayload[i].workpaperRefId);
          }

          dispatch(
            removeWorkpaperFromElementPanelWithSocketPayload(workpaperIdSet),
          );
          dispatch(elementWorkpaperListLoadedWithoutResponse());
        }

        // this action will determine if the element search content component will render the
        // filter refresh button

        if (elementSearchResults.isLoaded) {
          dispatch(showElementSearchRefreshButtonAction(true));
        }
        break;

      case NOTIFICATION_EVENT_TYPES.WORKPAPER_DELETED:
        if (left === LEFT_PANELS.WORKPAPER) {
          dispatch(deleteWorkpaperWithSocketPayloadAction(webSocketPayload));
        }
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(removeWPFromElementPanelAction(webSocketPayload));
        }

        break;

      case NOTIFICATION_EVENT_TYPES.WORKPAPER_UPDATE:
        if (left === LEFT_PANELS.WORKPAPER) {
          dispatch(updateWorkpaperWithSocketPayloadAction(webSocketPayload));
        }
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(updateWPFromElementPanelAction(webSocketPayload));
        }
        break;

      case NOTIFICATION_EVENT_TYPES.NOTE_DELETE:
        /*
          expected payload: 
          {
            "revisionId": 2,
            "sectionId": 13,
            "noteId": 150,
            "pseudoElementId": 1
          }
        */
        /*
          since there is no batch delete for notes, we do not need a specific payload or event type
          to update the Summary Notes. Therefore, we can always subtract 1 to the notes summary when 
          a note is deleted
        */
        dispatch(updateSummaryNotesFromWebsocket(-1));

        // this action removes the deleted note from the note cache
        dispatch(removeNoteFromCacheWithSocketPayloadAction(webSocketPayload));

        // this action deletes the affected note from the notes panel only if the notes panel is open
        if (right === RIGHT_PANELS.NOTES) {
          dispatch(deleteNoteWithWebsocketPayload(webSocketPayload));
          dispatch(notesListLoadedWithoutReponse());
        }

        // this action removes the deleted note from the content only if the user has the affected section in view
        if (!isOCRStatement && webSocketPayload.sectionId in elementCache) {
          dispatch(
            fetchAllSectionRenderingDataWithoutLoading({
              sectionId: webSocketPayload.sectionId,
            }),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.NOTE_ADD:
        /*
        since there is no batch delete for notes, we do not need a specific payload or event type
        to update the Summary Notes. Therefore, we can always add 1 to the notes summary when 
        a note is deleted
        */
        dispatch(updateSummaryNotesFromWebsocket(1));

        // when we add a note we still need to make this fetch call to update the content panel
        // we will only make this call if the affected section is in view
        if (webSocketPayload.sectionId in elementCache && isOCRStatement) {
          dispatch(
            fetchNotesBySectionOCR({
              sectionId: webSocketPayload.sectionId,
              withoutLoading: true,
            }),
          );
        } else if (
          webSocketPayload.sectionId in elementCache &&
          !isOCRStatement
        ) {
          dispatch(
            fetchAllSectionRenderingDataWithoutLoading({
              sectionId: webSocketPayload.sectionId,
            }),
          );
        }

        // this action adds the affected note from the notes panel only if the notes panel is open
        if (right === RIGHT_PANELS.NOTES) {
          // We need to modify the websocket payload to include additional details like parentId and isTechnical for particular section.
          // We expected to get these details from BE directly, but that they are facing some technical issues (inner join to fetch these
          // details causes ghost notes to dissappear from the list), which enforces us to fetch these details from sections cache.
          const { contentSectionMap } =
            getState().data.statementContent.sectionsCache;
          const sectionCacheData =
            contentSectionMap &&
            contentSectionMap.data &&
            contentSectionMap.data.map;
          let webSocketPayloadModified =
            sectionCacheData &&
            webSocketPayload.sectionId &&
            sectionCacheData[webSocketPayload.sectionId]
              ? {
                  ...webSocketPayload,
                  parentId:
                    sectionCacheData[webSocketPayload.sectionId].parentId,
                  isTechnical:
                    sectionCacheData[webSocketPayload.sectionId].isTechnical,
                }
              : webSocketPayload;
          dispatch(addNoteWithWebsocketPayload(webSocketPayloadModified));
          dispatch(notesListLoadedWithoutReponse());

          // only set the new note as selected if the user that created the note matches the id in the
          // current user reducer
          if (currentUser.id === webSocketPayloadModified.noteTaker) {
            webSocketPayloadModified.isNew = true;
            dispatch(
              selectNoteFromNoteListAction({
                note: new Note(webSocketPayloadModified),
              }),
            );
          }
        }

        break;

      case NOTIFICATION_EVENT_TYPES.NOTE_UPDATE:
        /*
          sample payload for note update. 
          payload = {
          "noteId":1313,
          "revisionId":1140,
          "sectionId":0,
          "pseudoElementId":1,
          "elementId":-1,
          "noteType":"I",
          "workflowStatus":"O",
          "closedBy":null,
          "closedByName":null,
          "body":"{\"note\":\"Nevada note\",\"replies\":{}}",
          "noteDate":"2021-09-21T19:11:48Z",
          "closedDate":null,
          "noteTaker":130,
          "noteTakerName":"Lakshmi Reddyreddy",
          "notePriorityType":"NORMAL",
          "revisionNumber":1
          }
        NOTE: for note Updates we receive a reduced payload and not the entire note entity
        */

        if (right === RIGHT_PANELS.NOTES) {
          dispatch(updateNoteWithWebsocketPayload(webSocketPayload));
        }

        if (webSocketPayload.sectionId in elementCache) {
          dispatch(
            updateNoteFromNoteCacheWithSocketPayloadAction(webSocketPayload),
          );
        }
        break;
      case NOTIFICATION_EVENT_TYPES.HEADING_UPDATE:
        if (currentUser.id !== webSocketPayload.updatedBy) {
          dispatch(setStatementNavigationRefresh(true));
        }
        break;
      case NOTIFICATION_EVENT_TYPES.HEADING_REVIEW:
        {
          const {
            bookmarkReview,
            sectionReview,
            bookmarkHistory,
            sectionHistory,
          } = webSocketPayload;

          const sectionReviewData = isOCRStatement
            ? bookmarkReview
            : sectionReview;
          const historyData = isOCRStatement ? bookmarkHistory : sectionHistory;
          const appendHistoryCondition = isOCRStatement
            ? bookmarkReview?.bookmarkId === selectedSection.id
            : sectionReview?.sectionId === selectedSection.id;

          dispatch(
            appendSectionToSectionReviewList({
              review: sectionReviewData,
              isOCR: isOCRStatement,
            }),
          );
          if (
            right === RIGHT_PANELS.SECTION &&
            webSocketPayload &&
            sectionReviewData &&
            appendHistoryCondition
          ) {
            dispatch(appendSectionReviewHistory(historyData));
          }
        }
        break;
      case NOTIFICATION_EVENT_TYPES.HEADING_UNREVIEW:
        {
          const { bookmarkId, sectionId, userId } = webSocketPayload;

          const sectionOrBookmarkId = isOCRStatement ? bookmarkId : sectionId;
          const appendHistoryUnvreviewCondition = isOCRStatement
            ? bookmarkId === selectedSection.id
            : sectionId === selectedSection.id;

          dispatch(
            removeSectionReviewFromStore({
              sectionId: sectionOrBookmarkId,
              userId,
              isOCR: isOCRStatement,
            }),
          );
          if (
            right === RIGHT_PANELS.SECTION &&
            appendHistoryUnvreviewCondition
          ) {
            dispatch(appendSectionReviewHistory(webSocketPayload));
          }
        }
        break;
      default:
        break;

      case NOTIFICATION_EVENT_TYPES.COMFORT_LETTER_UPDATE:
        if (left === LEFT_PANELS.COMFORT_ANNOTATION) {
          dispatch(
            updateComfortLetterWithSocketPayloadAction(webSocketPayload),
          );
        }
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            updateComfortLetterInElementPanelWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.COMFORT_LETTER_DELETE:
        if (left === LEFT_PANELS.COMFORT_ANNOTATION) {
          dispatch(
            deleteComfortLetterWithSocketPayloadAction(webSocketPayload),
          );
        }
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            removeComfortLetterFromElementPanelWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.TICKMARK_UPDATE:
        if (left === LEFT_PANELS.TICKMARK) {
          dispatch(updateTickmarkWithSocketPayloadAction(webSocketPayload));
        }
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            updateTickmarkInElementPanelWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }
        break;

      case NOTIFICATION_EVENT_TYPES.TICKMARK_DELETE:
        if (left === LEFT_PANELS.TICKMARK) {
          dispatch(deleteTickmarkWithSocketPayloadAction(webSocketPayload));
        }
        if (right === RIGHT_PANELS.ELEMENT) {
          dispatch(
            removeTickmarkFromElementPanelWithSocketPayloadAction(
              webSocketPayload,
            ),
          );
        }
        break;
      case NOTIFICATION_EVENT_TYPES.ADD_SECTION_HEADING:
        {
          const {
            bookmarkId,
            sectionId: payloadSectionId,
            userIds,
            revisionId,
            createdDate,
          } = webSocketPayload;

          const sectionId = isOCRStatement ? bookmarkId : payloadSectionId;

          let sectionAssignmentListPayload = userIds.map((userId) => {
            const assignementPayload = {
              revisionId,
              userId,
              userName: getUserNameByUserData(userId, projectUsersList.users),
              date: createdDate,
            };
            isOCRStatement
              ? (assignementPayload.bookmarkId = bookmarkId)
              : (assignementPayload.sectionId = payloadSectionId);

            return assignementPayload;
          });

          dispatch(
            updateSectionAssignmentListFromSocket({
              sectionAssignmentListPayload,
              sectionId,
              currentUserId: currentUser.id,
              isOCR: isOCRStatement,
            }),
          );
          if (
            right === RIGHT_PANELS.SECTION &&
            selectedSection.id === sectionId
          ) {
            dispatch(replaceNewWithSocketData(sectionAssignmentListPayload));
            dispatch(
              fetchSectionHistoryDetails({
                revisionId,
                sectionId,
                isOCR: isOCRStatement,
              }),
            );
          }
          if (left === LEFT_PANELS.STATEMENT_NAV) {
            dispatch(setHeadingAssignmentRefresh(true));
          }
        }
        break;

      case NOTIFICATION_EVENT_TYPES.HEADING_DELETE:
        {
          const { bookmarkId, sectionId } = webSocketPayload;

          let sectionAssignmentListPayload = []; //Sending an empty payload in case of heading delete
          dispatch(
            updateSectionAssignmentListFromSocket({
              sectionAssignmentListPayload,
              sectionId: isOCRStatement ? bookmarkId : sectionId,
              currentUserId: currentUser.id,
              isOCR: isOCRStatement,
            }),
          );
          if (left === LEFT_PANELS.STATEMENT_NAV) {
            dispatch(setHeadingAssignmentRefresh(true));
          }
        }
        break;
      case NOTIFICATION_EVENT_TYPES.TICKMARK_LINKED:
        if (right === RIGHT_PANELS.ELEMENT) {
          const elementId = elementDetails.id;
          dispatch(
            elementTickmarkListFromWebSocketPayloadAction({
              webSocketPayload: webSocketPayload.attachedTickmark,
              elementId,
            }),
          );
        }
        if (left === LEFT_PANELS.TICKMARK) {
          dispatch(addTickmarkToListAction(webSocketPayload));
        }
        //we call the element update function here because for tickmark element update event, we are not going to get anything for element update event
        _elementUpdate(webSocketPayload.elementEntities);
        if (elementSearchResults.isLoaded) {
          dispatch(showElementSearchRefreshButtonAction(true));
        }
        break;
      case NOTIFICATION_EVENT_TYPES.TICKMARK_UNLINKED:
        if (left === LEFT_PANELS.TICKMARK) {
          dispatch(unlinkTickmarkFromElementWithWebsocket(webSocketPayload));
        }

        if (right === RIGHT_PANELS.ELEMENT) {
          const elementId = elementDetails.id;
          const tickmarkIdSet = new Set();
          for (let i = 0; i < webSocketPayload.length; i++) {
            webSocketPayload[i].elementId === elementId &&
              tickmarkIdSet.add(webSocketPayload[i].tickmarkId);
          }

          tickmarkIdSet.size > 0 &&
            dispatch(removeTickmarkWithSocketPayloadInBulk(tickmarkIdSet));
          dispatch(elementTickmarkListLoadedWithoutResponse());
        }

        // this action will determine if the element search content component will render the
        // filter refresh button

        if (elementSearchResults.isLoaded) {
          dispatch(showElementSearchRefreshButtonAction(true));
        }
        break;

      case NOTIFICATION_EVENT_TYPES.TOOLKIT_EXPORT_REPORT_STATUS:
        // check if the update is for concerned revisionId and userID
        if (
          webSocketPayload.revisionId === revision.id &&
          webSocketPayload.requestedUser === currentUser.id
        ) {
          dispatch(downloadReportAction(webSocketPayload));
        }
        break;

      case NOTIFICATION_EVENT_TYPES.BULK_SECTION_ASSIGN:
      case NOTIFICATION_EVENT_TYPES.BULK_BOOKMARK_ASSIGN:
        {
          const { bookmarkIds, sectionIds, userIds, revisionId, createdDate } =
            webSocketPayload;

          let sectionAssignmentListPayload = [];
          isOCRStatement
            ? webSocketPayload &&
              bookmarkIds &&
              bookmarkIds.forEach((bookmarkId) => {
                userIds.forEach((userId) => {
                  sectionAssignmentListPayload.push({
                    revisionId,
                    bookmarkId,
                    userId,
                    userName: getUserNameByUserData(
                      userId,
                      projectUsersList.users,
                    ),
                    date: createdDate,
                  });
                });
              })
            : webSocketPayload &&
              sectionIds &&
              sectionIds.forEach((sectionId) => {
                userIds.forEach((userId) => {
                  sectionAssignmentListPayload.push({
                    revisionId,
                    sectionId,
                    userId,
                    userName: getUserNameByUserData(
                      userId,
                      projectUsersList.users,
                    ),
                    date: createdDate,
                  });
                });
              });

          dispatch(
            updateSectionAssignmentListForBulkAssignFromSocket({
              sectionAssignmentListPayload,
              currentUserId: currentUser.id,
              isOCR: isOCRStatement,
            }),
          );

          const updateSectionAssinmentInBulkCondition = isOCRStatement
            ? bookmarkIds && bookmarkIds.includes(selectedSection.id)
            : sectionIds && sectionIds.includes(selectedSection.id);

          if (
            right === RIGHT_PANELS.SECTION &&
            webSocketPayload &&
            updateSectionAssinmentInBulkCondition
          ) {
            dispatch(
              updateSectionAssignmentInBulkFromSocket(
                sectionAssignmentListPayload,
              ),
            );
            dispatch(
              fetchSectionHistoryDetails({
                revisionId,
                sectionId: selectedSection.id,
                isOCR: isOCRStatement,
              }),
            );
          }
          if (left === LEFT_PANELS.STATEMENT_NAV) {
            dispatch(setHeadingAssignmentRefresh(true));
          }
        }
        break;

      case NOTIFICATION_EVENT_TYPES.BULK_SECTION_UNASSIGN:
      case NOTIFICATION_EVENT_TYPES.BULK_BOOKMARK_UNASSIGN:
        {
          const { bookmarkIds, sectionIds, revisionId } = webSocketPayload;

          dispatch(
            updateSectionAssignmentListForBulkUnAssignFromSocket({
              sectionAssignmentListPayload: isOCRStatement
                ? bookmarkIds
                : sectionIds,
              currentUserId: currentUser.id,
              isOCR: isOCRStatement,
            }),
          );
          const updateSectionAssinmentInBulkCondition = isOCRStatement
            ? bookmarkIds && bookmarkIds.includes(selectedSection.id)
            : sectionIds && sectionIds.includes(selectedSection.id);

          if (
            right === RIGHT_PANELS.SECTION &&
            webSocketPayload &&
            updateSectionAssinmentInBulkCondition
          ) {
            dispatch(updateSectionAssignmentInBulkFromSocket([]));
            dispatch(
              fetchSectionHistoryDetails({
                revisionId,
                sectionId: selectedSection.id,
                isOCR: isOCRStatement,
              }),
            );
          }
          if (left === LEFT_PANELS.STATEMENT_NAV) {
            dispatch(setHeadingAssignmentRefresh(true));
          }
        }
        break;
      case NOTIFICATION_EVENT_TYPES.BULK_SECTION_REVIEW:
      case NOTIFICATION_EVENT_TYPES.BULK_BOOKMARK_REVIEW:
        {
          let payloadSectionOrBookmarkIds = [];
          webSocketPayload &&
            webSocketPayload.forEach((item) => {
              payloadSectionOrBookmarkIds.push(
                item[isOCRStatement ? 'bookmarkId' : 'sectionId'],
              );
            });

          dispatch(
            mergeSectionReviewToSectionReviewList({
              reviewList: webSocketPayload,
              isOCR: isOCRStatement,
            }),
          );
          dispatch(
            fetchStatementSummarySections({
              revisionId: revision.id,
            }),
          );
          if (
            right === RIGHT_PANELS.SECTION &&
            webSocketPayload &&
            payloadSectionOrBookmarkIds.length &&
            payloadSectionOrBookmarkIds.includes(selectedSection.id)
          ) {
            dispatch(
              fetchSectionHistoryDetails({
                revisionId: revision.id,
                sectionId: selectedSection.id,
                isOCR: isOCRStatement,
              }),
            );
          }
          if (left === LEFT_PANELS.STATEMENT_NAV) {
            dispatch(setHeadingAssignmentRefresh(true));
          }
        }
        break;

      case NOTIFICATION_EVENT_TYPES.BULK_SECTION_UNREVIEW:
      case NOTIFICATION_EVENT_TYPES.BULK_BOOKMARK_UNREVIEW:
        {
          let payloadSectionOrBookmarkIds = [];

          webSocketPayload &&
            webSocketPayload.forEach((item) => {
              payloadSectionOrBookmarkIds.push(
                item[isOCRStatement ? 'bookmarkId' : 'sectionId'],
              );
            });

          dispatch(
            removeBulkSectionReviewFromStore({
              reviewList: webSocketPayload,
              isOCR: isOCRStatement,
            }),
          );
          dispatch(
            fetchStatementSummarySections({
              revisionId: revision.id,
            }),
          );
          if (
            right === RIGHT_PANELS.SECTION &&
            webSocketPayload &&
            payloadSectionOrBookmarkIds.length &&
            payloadSectionOrBookmarkIds.includes(selectedSection.id)
          ) {
            dispatch(
              fetchSectionHistoryDetails({
                revisionId: revision.id,
                sectionId: selectedSection.id,
                isOCR: isOCRStatement,
              }),
            );
          }

          if (left === LEFT_PANELS.STATEMENT_NAV) {
            dispatch(setHeadingAssignmentRefresh(true));
          }
        }
        break;

      case NOTIFICATION_EVENT_TYPES.BLACK_LINE_VIEW_GENERATED:
        dispatch(refetchSectionsInView());
        blacklineTogleNotification(BLACKLINE_VIEW_STATUS.COMPLETED);
        break;
      // TODO : Code to be uncommented when we are developing feature related to instant update of active users on statement.
      // case NOTIFICATION_EVENT_TYPES.USER_DISCONNECTED:
      //   dispatch(removeUserFromRoomAction(webSocketPayload));
      //   break;

      case NOTIFICATION_EVENT_TYPES.COMFORT_LETTER_LINKED:
        if (right === RIGHT_PANELS.ELEMENT) {
          const elementId = elementDetails.id;
          dispatch(
            elementComfortAnnotationListFromWebSocketPayloadAction({
              webSocketPayload: webSocketPayload.attachedComfortLetter,
              elementId,
            }),
          );
        }
        if (left === LEFT_PANELS.COMFORT_ANNOTATION) {
          dispatch(addComfortAnnotationToListAction(webSocketPayload));
        }
        _elementUpdate(webSocketPayload.elementEntities);
        break;

      case NOTIFICATION_EVENT_TYPES.COMFORT_LETTER_UNLINKED:
        if (left === LEFT_PANELS.COMFORT_ANNOTATION) {
          dispatch(
            unlinkComfortLetterFromElementWithWebsocket(webSocketPayload),
          );
        }

        if (right === RIGHT_PANELS.ELEMENT) {
          const elementId = elementDetails.id;
          const comfortLetterIdSet = new Set();
          for (let i = 0; i < webSocketPayload.length; i++) {
            webSocketPayload[i].elementId === elementId &&
              comfortLetterIdSet.add(webSocketPayload[i].comfortLetterId);
          }

          comfortLetterIdSet.size > 0 &&
            dispatch(
              removeComfortLetterFromElementPanelWithSocketPayloadInBulk(
                comfortLetterIdSet,
              ),
            );
          dispatch(elementComfortLetterListLoadedWithoutResponse());
        }

        // this action will determine if the element search content component will render the
        // filter refresh button

        if (elementSearchResults.isLoaded) {
          dispatch(showElementSearchRefreshButtonAction(true));
        }

        break;

      case NOTIFICATION_EVENT_TYPES.ELEMENT_CALLOUT_POSITION_UPDATE:
        dispatch(
          updateElementCacheByCalloutPosition({
            elementCalloutPosition: webSocketPayload,
          }),
        );
        break;

      case NOTIFICATION_EVENT_TYPES.ELEMENT_CALLOUT_POSITION_RESET:
        // eslint-disable-next-line no-case-declarations
        const loadedSectionsInView = Object.keys(sectionsInView);
        dispatch(resetCalloutPositionsInsideElementCache(loadedSectionsInView));
        break;
    }
  }
}
